"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var TswLogo = function TswLogo(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.34 515.45"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || 'The Ski Week Logo'), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    d: "m16.87,442.31v28.66c0,10.16,8.13,18.9,18.09,19.11h21.14c10.16-.21,18.3-8.94,18.3-19.11v-28.66c0-5.29-.2-12.81-10.77-20.13-6.71-4.47-20.33-14.44-26.22-18.5-6.51-4.47-10.37-6.71-10.37-16.67v-22.56c0-6.1,4.07-13.01,10.17-13.01h16.67c6.1,0,10.16,6.91,10.16,13.01v28.66h8.34v-28.66c0-10.16-8.13-18.91-18.3-19.11h-16.87c-10.17,0-18.3,8.94-18.3,19.11v24.6c0,8.13,3.25,13.82,12.4,19.92,8.34,5.69,17.28,12.19,24.8,17.89,6.71,4.88,10.16,7.52,10.16,15.45v28.66c0,6.1-4.27,13.01-10.37,13.01h-20.53c-6.1,0-10.16-6.91-10.16-13.01v-28.66h-8.33Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    points: "96.68 345.96 96.68 489.47 104.61 489.47 104.61 434.99 116 412.83 143.84 489.47 152.18 489.47 120.26 404.1 150.15 345.96 141.81 345.96 104.61 418.73 104.61 345.96 96.68 345.96"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    x: "170.8",
    y: "345.96",
    width: "8.34",
    height: "143.51"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    points: "268.5 489.47 270.54 489.47 289.03 371.98 307.33 489.47 309.36 489.47 315.66 489.47 317.69 489.47 340.26 345.96 331.92 345.96 312.61 469.96 293.1 345.96 284.76 345.96 265.45 469.96 245.94 345.96 237.6 345.96 260.17 489.47 262.2 489.47 268.5 489.47"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    points: "409.09 352.06 409.09 345.96 357.66 345.96 357.66 489.47 363.96 489.47 366 489.47 409.9 489.47 409.9 483.38 366 483.38 366 415.68 400.76 415.68 400.76 409.58 366 409.58 366 352.06 409.09 352.06"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    points: "476.91 352.06 476.91 345.96 425.48 345.96 425.48 489.47 431.78 489.47 433.82 489.47 477.72 489.47 477.72 483.38 433.82 483.38 433.82 415.68 468.58 415.68 468.58 409.58 433.82 409.58 433.82 352.06 476.91 352.06"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    points: "493.5 345.96 493.5 489.47 501.43 489.47 501.43 434.99 512.81 412.83 540.66 489.47 549 489.47 517.08 404.1 546.96 345.96 538.63 345.96 501.43 418.73 501.43 345.96 493.5 345.96"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    x: ".89",
    y: "319.98",
    width: "564.93",
    height: "7.13"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    x: ".89",
    y: "508.32",
    width: "564.93",
    height: "7.13"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill,
      strokeWidth: 0
    },
    d: "m111.01,87.15l61.2,120.46-45.07,83.27h95.37l-42.25-83.17L284.58,14.99l105.44,195.14-39.73,80.76h91.47l-43.72-80.91,59.86-121.68,102.06,201.62,6.36-3.22-108.52-214.37-63.93,129.95L284.59,0l-108.26,199.99L111.07,71.52,0,286.22l6.33,3.28L111.01,87.15Zm28.09,196.61l37.03-68.42,34.75,68.42h-71.79Zm290.71,0h-68.06l32.44-65.93,35.62,65.93Z"
  }));
};
TswLogo.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
TswLogo.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = TswLogo;